import React from "react";
import { useTranslation } from "react-i18next";
import {
  formatFirstOptionRow,
  formatSecondOptionRow,
} from "common-client/utils/search";
import { SearchResultProps } from "common-client/utils/search";
import Loading from "../Common/Icons/Loading";
import { Body } from "../Common/Typography";
import { Status } from ".";
import { SearchResult } from "./__queries__/getSearchResults";
import {
  CenterContentContainer,
  Dropdown,
  Option,
} from "./__styles__/Dropdown";

export const ResultsDropdown = ({
  results,
  onClear,
  handleResultClick,
  resetSearchCategory,
  status,
  setValue,
}: {
  results: Array<Maybe<SearchResult>>;
  onClear: () => void;
  handleResultClick: (searchResult: SearchResultProps) => void;
  resetSearchCategory: () => void;
  status: Status;
  setValue: (name: "address", value: null) => void;
}) => {
  const { t } = useTranslation();

  const handleResult = (result: SearchResult) => {
    setValue("address", null);
    onClear();
    resetSearchCategory();
    const [longitude, latitude] = result!.coordinates.split(",").map(Number);
    handleResultClick({
      point: { longitude: longitude!, latitude: latitude! },
      address: result?.address!,
      propertyId: result?.propertyId,
      geocacheParcelId: result?.geocacheParcelId,
      streetAddress: result.streetAddress,
      city: result.city,
      state: result.state,
      zip: result.zip,
    });
  };

  return (
    <Dropdown data-testid="search-dropdown">
      {status === "search_complete" && !results.length && (
        <CenterContentContainer>
          <Body size="default" type="regular">
            {t("search-no-results")}
          </Body>
        </CenterContentContainer>
      )}
      {status === "loading" && (
        <CenterContentContainer data-testid="loading" tabIndex={0}>
          <Loading size="small" />
        </CenterContentContainer>
      )}
      {results.map((result, index) => (
        <Option
          key={index}
          tabIndex={0}
          onClick={() => handleResult(result!)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              handleResult(result!);
            }
          }}
        >
          <Body size="large" type="emphasis">
            {formatFirstOptionRow({
              searchResult: result!,
              blockLabel: t("search-block"),
              lotLabel: t("search-lot"),
            })}
          </Body>
          <Body size="large" type="regular">
            {formatSecondOptionRow(result!)}
          </Body>
        </Option>
      ))}
    </Dropdown>
  );
};
